import { displayApiValidationErrors, findPos } from '../../helpers';

import Vue from 'vue';
import { generateUrlFunction } from '../data/meddream';
import isEqual from 'lodash/isEqual';
import toastr from 'toastr';

export const CaseView = {
  state: {
    case: null,
    replies: [],
    diagnoses: [],
    tags: [],
    recommendedCases: [],
    similarCases: [],
    caseStudies: [],
    viewerUrl: '',
    caseModalVisible: false,
    aiEngines: [],
    viewerActiveElement: 1,
  },

  getters: {
    // TODO: use mapState and remove getter
    originCase: (state) => {
      return state.case;
    },

    // TODO: use mapState and remove getter
    getCaseStudies: (state) => {
      return state.caseStudies;
    },

    isFollowingCase: (state) => {
      return state.case?.isFollowingCase;
    },

    isCaseEditable: function (state) {
      let haveVotersCount = state.case.diagnosis ? state.case.diagnosis.agreeVotesCount > 0 : false;

      return state.replies.length < 1 && !haveVotersCount && state.case.can.updateCase;
    },

    canAddStudyToCase: (state) => {
      return state.case.can.updateCase;
    },

    // TODO: use mapState and remove getter
    recommendedCases: (state) => {
      return state.recommendedCases;
    },

    // TODO: use mapState and remove getter
    similarCases: (state) => {
      return state.similarCases;
    },

    // TODO: use mapState and remove getter
    replies: (state) => {
      return state.replies;
    },

    // TODO: use mapState and remove getter
    tags: (state) => {
      return state.tags;
    },

    dicomStudies: (state) => {
      return state.case.studies.filter((study) => study.isDicomStudy);
    },

    // TODO: use mapState and remove getter
    viewerUrl: (state) => {
      return state.viewerUrl;
    },

    getReply: (state) => (reply) => {
      return state.replies.find(({ id }) => id === reply.id);
    },

    caseDiagnoses: (state) => {
      return state.diagnoses.filter(({ originCase }) => !!originCase && originCase.id === state.case.id);
    },

    mainDiagnosis: ({ diagnoses }) => diagnoses.find(({ originReply }) => !originReply),

    getReplyDiagnosis: (_, getters) => (reply) => {
      return getters.caseDiagnoses.find(({ originReply }) => !!originReply && originReply.id === reply.id);
    },

    bestDiagnoses: (_, getters) => {
      return getters.caseDiagnoses.concat().sort((a, b) => {
        const diff = b.agreeVotesCount - a.agreeVotesCount;
        return diff === 0 ? 0 : diff / Math.abs(diff);
      });
    },

    // TODO: use mapState and remove getter
    caseModalVisible: (state) => {
      return state.caseModalVisible;
    },

    // TODO: use mapState and remove getter
    aiEngines: (state) => {
      return state.aiEngines;
    },

    // TODO: use mapState and remove getter
    getViewerActiveElement: (state) => {
      return state.viewerActiveElement;
    },
  },

  mutations: {
    setViewerActiveElement: (state, el) => {
      state.viewerActiveElement = el;
    },

    setViewerUrl(state, viewerUrl) {
      state.viewerUrl = viewerUrl;
    },

    setCase(state, originCase) {
      state.case = originCase;
    },

    setIsFollowingCase(state, value) {
      state.case.isFollowingCase = value;
    },

    setCaseModalVisible(state, visible) {
      state.caseModalVisible = visible;
    },

    addReply(state, reply) {
      const index = state.replies.findIndex((object) => object.id === reply.id);
      if (index === -1) {
        state.replies.push(reply);
      }
    },

    editReply(state, reply) {
      let index = state.replies.findIndex((r) => r.id === reply.id);
      let updatedReply = { ...reply, diagnosis: { ...reply.diagnosis } };
      Vue.set(state.replies, index, updatedReply);
    },

    addDiagnosis(state, diagnosis) {
      // We check if the dignosis is already present in the state, if not we add it
      const isPresent = state.diagnoses.some((item) => isEqual(item, diagnosis));
      if (!isPresent) {
        if (!diagnosis.originReply) {
          // If doesn't have originReply, it is the main diagnosis, so we add or replace existing one
          const mainDiagnosisIndex = state.diagnoses.findIndex(d => d.originCase.id === diagnosis.originCase.id);

          if (mainDiagnosisIndex !== -1) {
            state.diagnoses[index] = diagnosis;
          } else {
            state.diagnoses.push(diagnosis);
          }
        } else {
          // If it's a reply diagnosis, then add it
          state.diagnoses.push(diagnosis);
        }
      }
    },

    addCaseStudy(state, study) {
      state.caseStudies.push(study);
    },

    editCaseDiagnosis(state, diagnosis) {
      let diagnosisObject = state.diagnoses.find((el) => el.originCase.id === diagnosis.originCase.id);
      if (diagnosisObject) {
        diagnosisObject.details = diagnosis.details;
        diagnosisObject.confidenceLevel = diagnosis.confidenceLevel;
      } else {
        state.diagnoses.push(diagnosis);
      }
    },

    editDiagnosis(state, diagnosis) {
      let diagnosisObject = state.diagnoses.find((el) => el.originReply.id === diagnosis.originReply.id);
      if (diagnosisObject) {
        diagnosisObject.details = diagnosis.details;
        diagnosisObject.confidenceLevel = diagnosis.confidenceLevel;
      } else {
        state.diagnoses.push(diagnosis);
      }
    },

    removeReplyDiagnosis(state, reply) {
      state.diagnoses = state.diagnoses ? state.diagnoses.filter((el) => el.originReply.id !== reply.id) : [];
    },

    removeCaseDiagnosis(state, originCase) {
      state.diagnoses = state.diagnoses ? state.diagnoses.filter((el) => el.originCase.id !== originCase.id) : [];
    },

    resetDiagnoses(state) {
      state.diagnoses = [];
    },

    setVoters(_, { diagnosis, users }) {
      diagnosis.voters = users;
      diagnosis.agreeVotesCount = users.length;
    },

    setAgree(_, { diagnosis, agree }) {
      diagnosis.agree = agree;
      diagnosis.agreeVotesCount += agree ? 1 : -1;
    },

    setTags(state, tags) {
      state.tags = tags;
    },

    setRecommendedCases(state, cases) {
      state.recommendedCases = cases;
    },

    setSimilarCases(state, cases) {
      state.similarCases = cases;
    },

    setAiEngines(state, aiEngines) {
      state.aiEngines = aiEngines;
    },

    setFollowersCount(state, followersCount) {
      state.case.followersCount = followersCount;
    },
  },

  actions: {
    getCase({ dispatch, commit }, caseId) {
      commit('setBusy', true);
      commit('resetDiagnoses');
      this._vm
        .$api('cases.show', ['1.0', caseId])
        .then((response) => {
          let resultCase = response.data.data;

          //set case title as page title
          this._vm.$page.props.pageTitle = resultCase.title;

          dispatch('initStore', resultCase);
          dispatch('getAiEngines', resultCase.id);
          dispatch('getCaseAnalyses', resultCase.id);
          dispatch('getRecommendedCases', resultCase.id);
          dispatch('getSimilarCases', resultCase.id);
          commit('setBusy', false);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            let errors = JSON.parse(JSON.stringify(error.response.data.errors));
            displayApiValidationErrors(errors);
          }
        });
    },

    async editCase({ state, commit }, form) {
      commit('setBusy', true);
      try {
        let response = await this._vm.$api('cases.update.handle', ['1.0', state.case], form);
        let responseCase = response.data.data;
        commit('setCase', responseCase);
        if (responseCase.diagnosis) {
          commit('editCaseDiagnosis', responseCase.diagnosis);
        } else {
          commit('removeCaseDiagnosis', responseCase);
        }

        toastr.success('Data saved successfully');
        commit('setCaseModalVisible', false);
      } catch (error) {
        if (error.response?.data) {
          let errors = JSON.parse(JSON.stringify(error.response.data.errors));
          displayApiValidationErrors(errors);
        }
      }
      commit('setBusy', false);
    },

    async getRecommendedCases({ commit }, caseId) {
      try {
        let response = await this._vm.$api('cases.recommended-cases', ['1.0', caseId]);
        commit('setRecommendedCases', response.data.data);
      } catch (error) {
        throw new Error(error);
      }
    },

    async getSimilarCases({ commit }, caseId) {
      try {
        let response = await this._vm.$api('cases.similar-cases', ['1.0', caseId]);
        commit('setSimilarCases', response.data.data);
      } catch (error) {
        throw new Error(error);
      }
    },

    async getCaseAnalyses({ commit }, caseId) {
      try {
        let response = await this._vm.$api('cases.analyses.index', ['1.0', caseId]);
        commit('setAnalyses', response.data.data);
      } catch (error) {
        throw new Error(error);
      }
    },

    async getAiEngines({ commit }, caseId) {
      try {
        let response = await this._vm.$api('cases.ai-engines', ['1.0', caseId]);
        commit('setAiEngines', response.data.data);
      } catch (error) {
        throw new Error(error);
      }
    },

    updateViewerUrl({ state, commit }) {
      let dicomStudies = state.caseStudies.filter((study) => study.isDicomStudy);
      const studyUids = dicomStudies.map(({ studyInstanceUid }) => studyInstanceUid);

      let viewUrlResult = generateUrlFunction(studyUids, false, state?.case?.id);
      viewUrlResult().then((response) => {
        commit('setViewerUrl', response);
      });
    },

    followCase({ state, commit, rootState }, originCase = null) {
      let repositoryCase =
        originCase !== null ? JSON.parse(JSON.stringify(originCase)) : JSON.parse(JSON.stringify(state.case));
      return this._vm.$api('cases.followers.store', ['1.0', repositoryCase], rootState.currentUser).then((response) => {
        toastr.success('You followed case: ' + repositoryCase.title);
        commit('feedSetFollowingCase', repositoryCase.id);
        if (originCase === null) {
          commit('setFollowersCount', response.data.followersCount);
          commit('setIsFollowingCase', true);
        }
      });
    },

    unFollowCase({ state, commit, rootState }, originCase = null) {
      let repositoryCase =
        originCase !== null ? JSON.parse(JSON.stringify(originCase)) : JSON.parse(JSON.stringify(state.case));
      return this._vm
        .$api('cases.followers.destroy', ['1.0', repositoryCase, rootState.currentUser])
        .then((response) => {
          toastr.success('You unfollowed case: ' + repositoryCase.title);
          commit('feedSetUnFollowingCase', repositoryCase.id);
          if (originCase === null) {
            commit('setFollowersCount', response.data.followersCount);
            commit('setIsFollowingCase', false);
          }
        });
    },

    initStore({ dispatch, commit }, originCase) {
      commit('setCase', originCase);
      if (originCase.diagnosis) {
        commit('addDiagnosis', originCase.diagnosis);
      }

      if (originCase.tags) {
        commit('setTags', originCase.tags);
      }

      originCase.replies?.forEach((reply) => dispatch('addReply', reply));
      originCase.studies?.forEach((study) => commit('addCaseStudy', study));
      originCase.keyImages?.forEach((image) => commit('addKeyImage', image));
      originCase.removedImages?.forEach((image) => commit('addRemovedImage', image));
      originCase.newImages?.forEach((image) => commit('addNewImage', image));

      dispatch('updateViewerUrl');
    },

    getVoters({ commit }, diagnosis) {
      const routeName = 'cases' + (diagnosis.originReply ? '.replies' : '') + '.diagnosis.voters.index';
      const routeParams = { version: '1.0', case: diagnosis.originCase, reply: diagnosis.originReply };

      return this._vm
        .$api(routeName, routeParams)
        .then((response) => {
          commit('setVoters', { diagnosis, users: response.data.data });
        })
        .catch(() => {});
    },

    setAgree({ commit, rootState }, { diagnosis, agree }) {
      const routeName =
        'cases' + (diagnosis.originReply ? '.replies' : '') + '.diagnosis.voters.' + (agree ? 'store' : 'destroy');
      const routeParams = {
        version: '1.0',
        case: diagnosis.originCase,
        reply: diagnosis.originReply,
        voter: agree ? null : rootState.currentUser,
      };
      const postData = { id: rootState.currentUser.id };

      return this._vm
        .$api(routeName, routeParams, postData)
        .then(() => {
          commit('setAgree', { diagnosis, agree });
        })
        .catch(() => {});
    },

    addReply({ commit }, reply) {
      commit('addReply', reply);

      if (reply.diagnosis) {
        commit('addDiagnosis', reply.diagnosis);
      }

      reply.images.forEach((image) => commit('addKeyImage', image));
    },

    editReply({ commit }, reply) {
      commit('editReply', reply);

      if (reply.diagnosis) {
        commit('editDiagnosis', reply.diagnosis);
      } else {
        commit('removeReplyDiagnosis', reply);
      }

      reply.images.forEach((image) => commit('addKeyImage', image));
    },

    createReply({ dispatch, state, getters }, reply) {
      const routeName = 'cases.replies.store';
      const routeParams = { version: '1.0', case: state.case, html: true };

      return this._vm.$api(routeName, routeParams, reply).then((response) => {
        const newReply = response.data.data;
        dispatch('addReply', newReply);
        if (!state.case.isFollowingCase) {
          dispatch('followCase');
        }
        return getters.getReply(newReply);
      });
    },

    updateReply({ dispatch, state, getters }, reply) {
      const routeName = 'cases.replies.update';
      const routeParams = { version: '1.0', case: state.case, reply: reply.id, html: true };
      return this._vm.$api(routeName, routeParams, reply).then((response) => {
        let updatedReply = response.data.data;
        if (!updatedReply.images.length && reply.images.length) {
          updatedReply.images = reply.images;
        }
        dispatch('editReply', updatedReply);
        return getters.getReply(updatedReply);
      });
    },

    getNewReplies({ dispatch, state, getters }) {
      const routeName = 'cases.replies.index';
      const routeParams = { version: '1.0', case: state.case, html: true };

      return this._vm.$api(routeName, routeParams).then((response) => {
        const replies = response.data.data;
        replies.filter((reply) => !getters.getReply(reply)).forEach((reply) => dispatch('addReply', reply));
        return replies;
      });
    },

    updateSidebar({ state, commit }) {
      return Promise.all([
        this._vm
          .$api('cases.unique-tags', ['1.0', state.case])
          .then((response) => commit('setTags', response.data.data)),

        this._vm
          .$api('cases.recommended-cases', ['1.0', state.case])
          .then((response) => commit('setRecommendedCases', response.data.data)),

        this._vm
          .$api('cases.similar-cases', ['1.0', state.case])
          .then((response) => commit('setSimilarCases', response.data.data)),
      ]);
    },

    addStudiesToCase({ state, commit, dispatch }, studies) {
      let payload = {};
      payload.studies = studies;
      commit('setBusy', true);
      let caseId = state.case.id;
      this._vm.$api('cases.add-studies', ['1.0', caseId], payload).then((response) => {
        // add key images in state
        let images = response.data.keyImages;
        images.forEach((image) => commit('addKeyImage', image));

        // add studies in state
        let studies = response.data.studies;
        studies.forEach((study) => commit('addCaseStudy', study));

        //update meddream button url as new studies was added
        dispatch('updateViewerUrl');

        commit('setBusy', false);

        toastr.success('Data saved successfully');

        // scroll to key images
        window.scroll(0, findPos(document.getElementsByClassName('timeline')));
        // set timeline button active
        commit('setViewerActiveElement', 2);
      });
    },
  },
};
